<template>
  <div class="content" :class="{overHidden:modelStatus}">
    <div class="nav " :class=" {nav_top:scrollTop}">
      <div class="logo_box">
        <img src="../assets/logo.png" alt="" v-if="!scrollTop">
        <img src="../assets/LOGO_hei.png" v-else alt="">
      </div>
      <div class="nav_content">
        <ul>
          <li class="item " @click="goTo('Home')"><span >HOME</span></li>
          <li class="item ours ">
            <span v-if="lang=='en'">OUR PRODUCTS</span>
            <span v-if="lang=='it'">NOSTRI PRODOTTI</span>
            <div class="our">
              <div class="items "  v-if="lang=='en'" @click="goTo('Bodys')">BODY LOTION</div>
              <div class="items "  v-if="lang=='it'" @click="goTo('Bodys')">CREMA CORPO</div>
              <div class="items"    @click="goTo('SHam')" >SHAMPOO</div>
              <div class="items" @click="goTo('Bodys')" v-if="lang=='en'">BATH & SHOWER GEL</div>
              <div class="items" @click="goTo('Bodys')" v-if="lang=='it'">BAGNO DOCCIA</div>
            </div>
          </li>
          <li class="item" @click="goTo('Story')" v-if="lang=='en'"><span>STORY & HISTORY</span></li>
          <li class="item" @click="goTo('Story')"  v-if="lang=='it'"><span>STORIA</span></li>
          <li class="item" @click="goTo('Contact')" v-if="lang=='en'"><span class="navActive">CONTACT US</span></li>
          <li class="item" @click="goTo('Contact')" v-if="lang=='it'"><span class="navActive">CONTATTACI</span></li>
        </ul>
      </div>
      <div class="phone-nav-content" v-if="modelStatus" @click="toggleModel">
        <ul v-if="!twoBoxStatus">
          <li class="item " @click="goTo('Home')">HOME</li>
          <li class="item right-arrow" @click.stop="twoBox">{{lang=='en'?'OUR PRODCTS':'NOSTRI PRODOTTI'}}</li>
          <li class="item" @click="goTo('Story')">{{lang=='en'?'STORY & HISTORY':'STORIA'}}</li>
          <li class="item active" @click="goTo('Contact')">  {{lang=='en'?'CONTACT US':'CONTATTACI'}}</li>
          <li class="langp" @click="langFn">
            <span :class="{langActive:lang=='en'}">EN</span>/<span class="IT" :class="{langActive:lang!='en'}">IT</span>
          </li>
        </ul>
        <div class="titleBack " v-if="twoBoxStatus" @click.stop="goBack">
          <div class="back" style="width: 0.32rem;height: .32rem">
            <img style="width: 100%;height: 100%" src="../assets/back.png" alt="">
          </div>
         <div class="titleText" style="font-size: 1rem;color: #231815;margin-top: .5rem" v-if="lang=='en'">
            <p>OUR</p>
            <p>PRODUCTS</p>
          </div> <div class="titleText" style="font-size: 1rem;color: #231815;margin-top: .5rem" v-if="lang=='it'">
            <p>NOSTRI</p>
            <p>PRODOTTI</p>
          </div>
        </div>
        <ul class="two" v-if="twoBoxStatus">
          <li class="item" @click="goTo('Bodys')"> {{lang=='en'?'BODY LOTION':'CREMA CORPO'}}</li>
          <li class="item" @click="goTo('Sham')">SHAMPOO</li>
          <li class="item" @click="goTo('Bath')">{{lang=='en'?'BATH & SHOWER GEL':'BAGNO DOCCIA'}}</li>
        </ul>
      </div>
      <div class="click_box" @click="toggleModel">
        <div class="top_flag"></div>
        <div class="bottom_flag"></div>
      </div>
      <div class="lang"  :class=" {lang_top:scrollTop}" @click="langFn">
        <span :class="{langActive:lang=='en'}">EN</span>/<span class="IT" :class="{langActive:lang!='en'}">IT</span>
      </div>
    </div>
    <div class="main_content">
      <div class="banner_box">
      </div>
      <div class="story_box main_item">
        <div class="message_text">
          <div class="story_flag"></div>
          <div class="text_title" v-if="lang=='en'">
            STORY &
            HISTORY
          </div>
          <div class="text_title" v-if="lang=='it'">
            STORIA
          </div>
          <div class="text_content" v-if="lang=='en'">
            Our products come from the pristine lands in Italy, where the four seasons orchestra with the nature harmoniously. Here, plants are grown organically, and in full respect of their natural life cycles. Our essence comes from botanics that are hand-harvested and dried naturally. We use only traditional crafting methods to preserve the best quality of active ingredients. No products of Fonte Del Borgo contain paraffins, petrolatum, silicones or parabens.
          </div>
          <div class="text_content" v-if="lang=='it'">Fonte del Borgo è nata da una storia d’amore e dalla passione per la natura. Spesso insegna ai visitatori il concetto di estetica bocanica in un mare di fiori, creando una cultura unica nelle quattro stagioni e applicandola al marchio - Fonte del Borgo.</div>
          <!--<div class="more">more</div>-->
        </div>
        <div class="story_image"></div>
      </div>
      <div class="contact_box main_item">
        <div class="contact_title" v-if="lang=='en'">CONTACT US</div>
        <div class="contact_title" v-if="lang=='it'">CONTATTACI</div>
        <div class="company">COMPANY</div>
        <div class="address">
          <div class="address-title">E-Mail</div>
          <div class="address-content">
            infosales@fontedelborgo.com
          </div>
        </div>
        <!--<div class="call_box">-->
          <!--<div class="call_us">-->
            <!--Call us-->
          <!--</div>-->
          <!--<div class="phoneMessage">-->
            <!--<h3>office telephone</h3>-->
            <!--<p> 0571-87241689</p>-->
          <!--</div>-->
        <!--</div>-->
        <div class="img_box">
          <img src="../assets/contact.jpg" alt="">
        </div>
      </div>
      <div class="pc_contact_box main_item">
        <div class="top_box">
          <div class="img_box"></div>
          <div class="rightBox">
            <div class="right_title" v-if="lang=='en'">
              <p>CONTACT</p>
              <p>US</p>
            </div>
            <div class="right_title" v-if="lang=='it'">
              <p>CONTATTACI</p>
            </div>
            <div class="topBox">COMPANY</div>
            <div class="bottomBox">
              <div class="title">E-Mail</div>
              <div class="message">
                <p>infosales@fontedelborgo.com</p>
              </div>
            </div>
          </div>
        </div>
        <div class="bottom_box"></div>
      </div>
    </div>
    <myFooter></myFooter>
  </div>
</template>
<style scoped lang="scss">
  .content {
    width: 100%;
    position: relative;
    .clear {
      clear: both;
    }

    .nav {
      width: 100%;
      height: 80px;
      display: flex;
      position: fixed;
      top: 0;
      left: 0;
      right: 0;
      margin: 0 auto;
      justify-content: space-around;
      align-items: center;
      box-sizing: border-box;
      margin: 0 auto;
      background-color: #000000;
      z-index: 1;
      font-family: CantoriaMT;
      .logo_box {
        height: 53px;
        width: 60px;
      }

      .nav_content {
        height: 100%;
        box-sizing: border-box;

        .item {
          display: inline-block;
          font-size: 14px;
          font-weight: normal;
          font-stretch: normal;
          letter-spacing: 0px;
          color: #666666;
          margin-right: 78px;
          line-height: 80px;
          position: relative;

          .our {
            position: absolute;
            top: 80px;
            left: -80px;
            width: 260px;
            height: 191px;
            background-color: #ffffff;
            box-shadow: 0px 4px 8px 0px rgba(0, 0, 0, 0.06);
            color: #999999;
            box-sizing: border-box;
            font-size: 14px;
            padding: 40px 43px 0;
            display: none;

            div {
              display: block;
              /*margin-bottom: 30px;*/
              height: 50px;
              line-height: 0px;
            }
          }

        }

        .navActive {
          color: #ffffff;
          border-bottom: 1px solid #FFFFFF;
        }

        .ours:hover .our {
          display: block;
        }
      }

      .hidden {
        visibility: hidden;
      }

      .phone-nav-content {
        display: none;
      }
      .lang{
        color:#666666;
        .langActive{
          color: #ffffff;
        }
      }
      .lang_top{
        color:#999999;
        .langActive{
          color: #000;
        }
      }
      .click_box {
        display: none;
        height: 30px;
        width: 30px;

        div {
          border-bottom: 1px solid #FFF;
          width: 30px;
          margin-top: 10px;
        }
      }
    }

    .nav_top {
      height: 80px;
      background-color: #ffffff;
      line-height: 80px;

      .nav_content {
        line-height: 80px;

        .item {
          line-height: 80px;
          font-weight: normal;
          font-stretch: normal;
          letter-spacing: 0px;
          color: #999999;

          .our {
            top: 70px;
          }
        }

        .navActive {
          border-bottom: 1px solid #231815;
          color: #231815;
        }

      }


    }


    .banner_box {
      position: relative;
      width: 100vw;
      height: 480px;
      background: url("../assets/banner-contact.png") no-repeat center;
      background-size: cover;
      overflow: hidden;
    }

    .main_content {
      .main_item {
        width: 1200px;
        margin: 0 auto;
        /*display: none;*/
        font-family: Konnect-Regular;
      }

      .story_box {

        margin-top: 160px;
        height: 561px;

        .message_text {
          float: left;
          width: 410px;
          height: 100%;
          position: relative;

          .story_flag {
            width: 18px;
            height: 3px;
            background-color: #231815;
          }

          .text_title {
            margin-top: 200px;
            width: 240px;
            height: 101px;
            font-family: CantoriaMT;
            font-size: 50px;
            font-weight: normal;
            font-stretch: normal;
            line-height: 50px;
            letter-spacing: 0px;
            color: #231815;
          }

          .text_content {
            width: 308px;
            height: 95px;
            font-family: Konnect-Regular;
            font-size: 14px;
            font-weight: normal;
            font-stretch: normal;
            line-height: 24px;
            letter-spacing: 0px;
            color: #9b9b9b;
          }

          .more {
            width: 70px;
            height: 21px;
            background-color: #231815;

            font-size: 14px;
            font-weight: normal;
            font-stretch: normal;
            letter-spacing: 1px;
            color: #ffffff;
            text-align: center;
            line-height: 21px;
            position: absolute;
            left: 0;
            bottom: 0;
          }
        }

        .story_image {
          float: left;
          width: 790px;
          height: 100%;
          background: url('../assets/story.jpg') no-repeat center;
          background-size: cover;
        }
      }

      .raff_box {
        padding: 100px 0;
        height: 790px;

        .message_text {
          float: left;
          height: 790px;
          position: relative;
          text-align: right;
          padding-left: 226px;

          .story_flag {
            width: 18px;
            height: 3px;
            background-color: #231815;
          }

          .text_title {
            margin-top: 302px;
            width: 354px;
            height: 150px;

            font-size: 50px;
            font-weight: normal;
            font-stretch: normal;
            line-height: 50px;
            letter-spacing: 0px;
            color: #231815;
          }

          .text_content {
            width: 354px;
            height: 94px;

            font-size: 14px;
            font-weight: normal;
            font-stretch: normal;
            line-height: 24px;
            letter-spacing: 0px;
            color: #9b9b9b;
          }

          .more {
            width: 70px;
            height: 21px;
            background-color: #231815;

            font-size: 14px;
            font-weight: normal;
            font-stretch: normal;
            letter-spacing: 1px;
            color: #ffffff;
            text-align: center;
            line-height: 21px;
            position: absolute;
            right: 0;
            bottom: 0;
          }
        }

        .raff_image {
          float: left;
          width: 620px;
          height: 790px;
          background: url('../assets/raff.png') no-repeat center;
        }
      }

      .iphone_raff {
        display: none;
      }

      .products_box {
        .tab_list {
          height: 50px;
          display: flex;
          justify-content: space-between;

          .title_text {
            width: 295px;
            height: 50px;

            font-size: 50px;
            font-weight: normal;
            font-stretch: normal;
            line-height: 50px;
            letter-spacing: 0px;
            color: #231815;
          }

          .list_item {
            width: 495px;
            height: 20px;
            font-size: 14px;
            font-weight: normal;
            font-stretch: normal;
            letter-spacing: 0px;
            color: #999999;
            display: flex;
            justify-content: space-between;

            li {
              display: inline-block;
            }

            .active {
              background-color: #231815;
              padding: 0 10px;
              line-height: 20px;
            }

          }
        }

        .body_lotion {
          height: 560px;
          margin-top: 130px;

          .message_title {
            width: 410px;
            float: left;
            padding-top: 357px;
            font-size: 20px;
            font-weight: normal;
            font-stretch: normal;
            letter-spacing: 0px;
            color: #231815;

            .more {
              font-size: 14px;
              margin-top: 134px;
            }
          }

          .body_img {
            float: left;
            width: 790px;
            height: 100%;
            background: url('../assets/story.png') no-repeat center;
          }
        }

        .orangeCitrus {
          margin-top: 160px;
          font-size: 20px;
          position: relative;
          height: 860px;

          .orange {
            width: 790px;
            height: 560px;
            float: left;

            .orange_img {
              float: left;
              width: 380px;
              height: 560px;
              background: url('../assets/raff.png') no-repeat center;
            }

            .orange_title {
              float: left;
              width: 277px;
              padding-left: 133px;

              .more {
                font-size: 14px;
                margin-top: 134px;
              }
            }
          }

          .citrus {
            width: 790px;
            height: 560px;
            float: right;
            position: absolute;
            top: 280px;
            right: 0;

            .citrus_img {
              float: right;
              width: 380px;
              height: 560px;
              background: url('../assets/raff.png') no-repeat center;
            }

            .citrus_title {
              float: left;
              width: 277px;
              position: absolute;
              bottom: 0;
              padding-left: 100px;

              .more {
                font-size: 14px;
                margin-top: 134px;
              }
            }
          }
        }

        .tan {
          height: 560px;
          margin-top: 140px;

          .message_title {
            position: relative;
            width: 410px;
            height: 100%;
            float: right;
            text-align: right;
            font-size: 20px;
            font-weight: normal;
            font-stretch: normal;
            letter-spacing: 0px;
            color: #231815;

            .title_box {
              position: absolute;
              right: 0;
              bottom: 0;

              .more {
                font-size: 14px;
                margin-top: 140px;
              }
            }

          }

          .tan_img {
            float: left;
            width: 790px;
            height: 100%;
            background: url('../assets/story.png') no-repeat center;
          }
        }
      }

      .phone_products_box {
        display: none;
      }
      .contact_box{
        display: none;
      }
      .pc_contact_box{
        display: block;
        margin-top: 160px;
        .img_box{
          display: inline-block;
          background: url("../assets/contact.jpg") no-repeat center;
          background-size: cover;
          width:600px;
          height: 600px;
        }
        .rightBox{
          display: inline-block;
          text-align: right;
          float: right;
          .right_title{
            font-family: CantoriaMT;
            font-size: 50px;
            line-height: 50px;
            color: #231815;
            margin-top: 100px;
          }
          .topBox{
            font-size: 16px;
            color: #231815;
            font-family: Konnect-Bold;
            margin-top: 180px;
          }
          .bottomBox{
            margin-top: 80px;
            .title{
              font-size: 14px;
              font-weight: normal;
              font-stretch: normal;
              line-height: 24px;
              letter-spacing: 0px;
              color: #231815;
            }
            .message{
              font-family: Helvetica;
              font-size: 14px;
              font-weight: normal;
              letter-spacing: 0px;
              color: #999999;
            }
          }
        }
      }

    }
  }

  @media screen and (max-width: 900) {
    .content {
      width: 100%;
      position: absolute;

      .nav {
        width: 100%;
        height: 0.88rem;
        margin: 0 auto;
        display: flex;
        justify-content: space-between;
        padding: 0 .3rem;
        align-items: center;
        box-sizing: border-box;
        font-family: CantoriaMT;
        .logo_box {
          height: 0.53rem;
          width: 0.6rem;

          img {
            width: 100%;
            height: 100%;
          }
        }

        .nav_content {
          display: none;

          .item {
            display: inline-block;
            font-size: 0.14rem;
            font-weight: normal;
            font-stretch: normal;
            letter-spacing: 0px;
            color: #666666;
            margin-right: 78px;
          }
        }

        .phone-nav-content {
          display: block;
          background-color: #fff;
          position: fixed;
          left: 0;
          right: 0;
          top: 0.88rem;
          bottom: 0;
          padding: 0.78rem 0.4rem;

          ul {
            display: flex;
            flex-direction: column;
            align-items: flex-start;
            animation: mymove 1s;
            position: absolute;
            top: 0.78rem;
            padding-left: 0.4rem;
            @keyframes mymove {
              from {
                left: 0;
              }
              to {
                left: .4rem;
              }
            }

            @-webkit-keyframes mymove /*Safari and Chrome*/
            {
              from {
                left: 0;
              }
              to {
                left: .4rem;
              }
            }

            .item {
              height: .36rem;
              font-size: .40rem;
              font-weight: normal;
              font-stretch: normal;
              letter-spacing: 0px;
              color: #999999;
              margin-top: 1.2rem;
              line-height: 0.36rem;
            }
            .right-arrow{
              background: url("../assets/right-arrow.png") no-repeat center right;
              background-size: .32rem .32rem;
              width: 4.5rem;
            }
            .back {

            }

            .active {
              border-bottom: 0.01rem solid #999999;
            }
          }

          ul.two {
            top: 4.75rem;
            padding-left: 0;

            .item {
              font-size: .32rem;
              margin-top: 0.6rem;

            }
          }
        }
        .langp {
          font-size: .3rem;
          color: #999999;
          margin-top: .4rem;

          .langActive {
            color: black;
            font-weight: bold;
          }
        }

        .click_box {
          height: 0.32rem;
          width: 0.32rem;
          display: block;

          div {
            border-bottom: 0.02rem solid #FFF;
            width: 0.32rem;
            margin-top: 0.1rem;
          }
        }
          .lang{
          display: none;
        }
      }

      .nav.nav_top {
        background-image: none;
        background-color: #fff;

        .click_box {
          div {
            border-bottom: 0.02rem solid black;
          }
        }
          .lang{
          display: none;
        }
      }

      .banner_box {
        position: relative;
        width: 100%;
        height: 6.4rem;
        background: url("../assets/contact-b.jpg") no-repeat center;
        background-size: cover;
        overflow: hidden;
        box-sizing: border-box;
      }

      .main_content {
        .main_item {
          width: 6.9rem;
          margin: 0 auto;
          display: block;
          padding: 0 0.3rem;
        }

        .story_box {
          margin-top: 1.2rem;
          height: auto;
          .message_text {
            float: none;
            width: 6.9rem;
            height: 5.64rem;
            position: relative;
            padding-bottom: .78rem;

            .story_flag {
              width: 0.2rem;
              height: 0.02rem;
              background-color: #231815;
            }

            .text_title {
              margin-top: 1.42rem;
              width: 2.4rem;
              height: 1rem;
              font-size: .5rem;
              font-weight: normal;
              font-stretch: normal;
              line-height: 0.5rem;
              letter-spacing: 0px;
              color: #231815;
              font-family: CantoriaMT;
            }

            .text_content {
              width: 6.9rem;
              font-family: Konnect-Regular;
              font-size: .24rem;
              font-weight: normal;
              font-stretch: normal;
              line-height: 24px;
              letter-spacing: 0px;
              color: #9b9b9b;
            }

          }

          .story_image {
            float: none;
            width: 6.9rem;
            height: 4.8rem;
            background: url('../assets/story.jpg') no-repeat center;
            background-size: cover;
            margin-top: 0.6rem;
          }
        }
        .contact_box{
          display: block;
          width: 6.9rem;
          margin-top: 1.6rem ;
          .contact_title{
            height: 1.36rem;
            font-size: .6rem;
            font-weight: normal;
            font-stretch: normal;
            letter-spacing: 0px;
            color: #231815;
            font-family: CantoriaMT;

          }
          .company{
            height: .26rem;
            font-family: Konnect-Bold;
            font-size: .26rem;
            font-weight: normal;
            font-stretch: normal;
            line-height: .24rem;
            letter-spacing: 3px;
            color: #231815;
          }
          .address{
            margin-top: .6rem;
            .address-title{

              font-family: Konnect-Regular;
              font-size: .24rem;
              font-weight: normal;
              font-stretch: normal;
              letter-spacing: 0px;
              color: #231815;
              line-height: .36rem;
            }
            .address-content{

              font-size: .24rem;
              font-weight: normal;
              letter-spacing: 0px;
              color: #999999;
            }
          }
          .call_box{
            font-family: Konnect-Bold;
            font-size: .26rem;
            font-weight: normal;
            font-stretch: normal;
            line-height: .24rem;
            letter-spacing: .03rem;
            color: #231815;
            margin-top: 1.2rem;
            .phoneMessage{
              font-family: Konnect-Regular;
                font-size: .24rem;
              margin-top: .6rem;
                p{
                  color: #999999;
                }
            }
          }
          .img_box{
            width: 6.9rem;
            height: 6.9rem;
            margin-top: 1.2rem;
            img{
              width: 100%;
              height: 100%;
            }
          }
        }
        .pc_contact_box{
          display: none;
        }
      }

    }
    .overHidden{
      overflow: hidden;
      height: 100vh;
    }

  }

</style>
<script>
  export default {
    name: 'HelloWorld',
    data() {
      return {
        scrollTop: 0,
        windowWidth:null,
        modelStatus:false,
        pcModelStatus:false,
        twoBoxStatus: false,
        lang:'en'
      }
    },
    mounted() {
      this.lang=this.defined.lang;
      this.windowWidth=window.document.documentElement.clientWidth;
      window.addEventListener('scroll', () => {
        const cHeight= document.getElementsByClassName('banner_box')[0].clientHeight
        if (document.documentElement.scrollTop > cHeight) {
          this.scrollTop = document.documentElement.scrollTop || document.body.scrollTop
        }else {
          this.scrollTop = 0;
        }


      })
    },
    methods: {
      goTo(data) {
        document.documentElement.scrollTop = 0;
        document.body.scrollTop = 0;
        this.$router.push({path: `/${data}`})
      },
      twoBox() {
        this.twoBoxStatus = true;
      },
      goBack() {
        this.twoBoxStatus = false;
      },
      langFn(){
        if(this.defined.lang=='en'){
          this.defined.setLang('it')
          this.lang='it'
        }else {
          this.defined.setLang('en')
          this.lang='en'
        }
      },
      toggleModel(){
        if(this.windowWidth<=1024&&!this.modelStatus){
          this.modelStatus=true

        }else if(this.windowWidth<=1024&&this.modelStatus){
          this.modelStatus=false
        }else if(this.windowWidth>1024&&!this.pcModelStatus){
          this.pcModelStatus=true;
        }else if(this.windowWidth>1024&&this.pcModelStatus){
          this.pcModelStatus=false;
        }
      }

    }

  }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->




// WEBPACK FOOTER //
// src/components/Contact.vue